import { useEffect, useState } from 'react';

/** Beats the finished scene holds before starting over. */
const HOLD = 3;

/**
 * The clock behind the product demos: it walks from 0 to `steps`, holds the finished scene for a
 * few beats, then starts over.
 *
 * Paused (manually or by `prefers-reduced-motion`) it reports the last step, so the demo is simply
 * the completed scene, which is the argument anyway. That case is derived at render time rather
 * than written back into state, which keeps the effect to one job: owning the interval.
 */
export function useSequence(steps: number, intervalMs: number, paused: boolean): number {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (paused) return;
    const timer = window.setInterval(() => {
      setTick((current) => (current >= steps + HOLD ? 0 : current + 1));
    }, intervalMs);
    return () => window.clearInterval(timer);
  }, [paused, steps, intervalMs]);

  return paused ? steps : Math.min(tick, steps);
}
